type TShirtModel = {
  id: number;
  path: string;
};

const tshirtPatterns: Record<number, TShirtModel> = {
  1: { id: 1, path: 'M175.03,164.27H35.9v-44.86h139.13v44.86Z' },
  2: {
    id: 2,
    path: 'M33.35,213.92H-10L150.81,11.71h43.35L33.35,213.92Z',
  },
  3: {
    id: 3,
    path: 'M154.31,2.18l22.39,11.18-31.03,58.24-40.56,76.14-40.56-76.14L32.54,11.49,55.05.53l9.51,17.85,40.56,76.14,40.56-76.14,8.63-16.2Z',
  },
  4: {
    id: 4,
    path: 'M174.39,259.14h-48.13V9.72h48.13v249.42ZM83.55,9.72h-48.13v249.42h48.13s0-249.42,0-249.42Z',
  },
  5: {
    id: 5,
    path: 'M137.58,6.63l61.81,28.27,15.21,83.87-43.93,63.23c-14.67-5.29-25.15-19.32-25.15-35.81v-56.69c0-.25-.02-.5-.04-.75.02-.5.04-.99.04-1.49,0-21.02-17.04-38.07-38.07-38.07s-38.07,17.04-38.07,38.07c0,.5.02.99.04,1.49-.02.25-.04.49-.04.75v56.69c0,16.49-10.48,30.52-25.15,35.81L-3.72,122.4,10.74,35.62,76.82,4.47l60.76,2.15Z',
  },
  6: { id: 6, path: 'M3.08,2.9h102.66v256.24H3.08V2.9Z' },
  7: { id: 7, path: 'M173.38,268.45H35.9v-133.3h137.48v133.3Z' },
  8: {
    id: 8,
    path: 'M99.14,269.5h-28.47V14.93h28.47s0,254.58,0,254.58ZM139.82,14.93h-28.47v254.58h28.47V14.93ZM182.52,14.93h-28.47v254.58h28.47V14.93ZM57.11,14.93h-28.47v254.58h28.47V14.93Z',
  },
  9: {
    id: 9,
    path: 'M36.97,25.85l27.46-17.4h81.24l16.99,8.82,33.77,20.8,7.31,17.21H4.57l6.71-13.3,25.69-16.14ZM.97,130.54h207.99v-46.84H.97v46.84ZM39.63,197.92h129.18v-46.84H39.63v46.84ZM39.63,273.18h129.18v-46.84H39.63v46.84Z',
  },
  10: {
    id: 10,
    path: 'M76.81,4.56l58.11,2.04,63.55,30.62,12.33,77.28-15.27,3.25h-27.18l-2.27,67.93.44,3.71L18.95,34.2,76.81,4.56Z',
  },
  11: {
    id: 11,
    path: 'M227.98,141.37H-18.7V-5.37h246.68v146.74Z',
  },
  12: {
    id: 12,
    path: 'M128.63,1.85l18.64,24.95v235.88l-84.44-.02V26.8L82.36,3.59l46.27-1.74Z',
  },
  13: {
    id: 13,
    path: 'M74.75,194.3l-5.97,82.6-31.92.21.2-82.81c-.14-1.96.47-3.79,1.57-5.19L135.48,13.01l1.32-2.81,56.24,24.15-118.78,164.61',
  },
  14: {
    id: 14,
    path: 'M72.68,4.25v260.01h-16.65V18.11s-.61-8.79,16.65-13.86ZM82.13,264.26h16.65V3.42h-16.65v260.83ZM108.23,264.26h16.64V3.42h-16.64v260.83ZM134.32,264.26h16.65V17.36s-1.36-9.09-16.65-13.11c0,0,0,260.01,0,260.01Z',
  },
  15: {
    id: 15,
    path: 'M-5.18-13.53L105.54,127.83,216.25-13.53v275.16H-5.18V-13.53h0Z',
  },
  16: {
    id: 16,
    path: 'M142.41,261.63h-31.93c7.1-28.58,10.71-60.22,9.9-93.46-1.45-59.12-16.54-112.41-39.97-151.66h13.69c23.45,34.12,41.3,79.39,49.21,130.81,6.22,40.46,5.49,79.59-.9,114.31ZM66.94,16.51H-40.5v245.12H93.63c7.18-27.39,11.19-57.63,11.19-89.45,0-60.56-14.45-115.46-37.88-155.67Z',
  },
  17: {
    id: 17,
    path: 'M48.11,20.78l13.33-7.31,4.79-2.52,105.55,134.27-.53,3.97.39,11.84.16,29.6L41.37,24.72l6.74-3.94ZM177.74,250.51l-3.7-43.97-.33-6.56L30.92,29.77l-4.64,2.84-11.81,4.99-8.88,5.34,167.89,213.59,4.26-6.02Z',
  },
  18: {
    id: 18,
    path: 'M37.03,65.12c13.98,6.91,22.73,17.93,26.48,32.94.73,2.93,1.03,6.05,1.04,9.08.08,29.1.31,58.21-.04,87.3-.25,21.05-14.75,39.1-35.03,44.82-2.32.65-4.59,1.46-6.88,2.2-6.62,0-13.25-.14-19.86.07-2.45.08-3.07-.38-3.06-2.98.11-34.58.08-69.15.08-103.73,0-24.03.04-48.07-.07-72.1-.01-2.3.59-2.64,2.69-2.59,6.98.15,21.97-.15,34.66,4.99ZM207.15,241.52c2.09.04,2.7-.29,2.68-2.59-.11-24.65-.07-49.29-.07-73.94,0-33.96-.04-67.93.08-101.89,0-2.6-.61-3.05-3.06-2.98-6.86.2-17.6-1.36-35.51,5.96-16.41,9.28-25.34,23.19-25.54,42.03-.31,28.71-.06,57.42-.11,86.13,0,3.34.45,6.6,1.25,9.78,3.88,15.33,13.11,26.23,27.38,33.02,3.87,1.84,8.29,2.07,11.93,4.43,6.99,0,13.98-.09,20.97.06Z',
  },
  19: {
    id: 19,
    path: 'M143.07,264.26h-75.82V38.24c0-11.93,8.04-21.59,17.96-21.59h39.91c9.92,0,17.96,9.67,17.96,21.59,0,0,0,226.01,0,226.01Z',
  },
  20: {
    id: 20,
    path: 'M140.79,60.45c.29-3.6.53-3.67,2.2-7.53,1.67-3.86,5.72,0,5.72,0l41.52,39.47v40.15l-1.15,2.7c-1.15,3.67-3.96,3.38-3.96,3.38h-14.07v123.54h-30.26s-.29-198.11,0-201.71ZM68.54,60.45c-.29-3.6-.53-3.67-2.2-7.53s-5.72,0-5.72,0l-41.52,39.47v40.15l1.15,2.7c1.15,3.67,3.96,3.38,3.96,3.38h14.07v123.54h30.26s.29-198.11,0-201.71Z',
  },
  21: {
    id: 21,
    path: 'M205.75,143.1c-58.95,2.1-76.3,67.62-76.3,67.62V54.8c9.11-32.94,76.3-25.11,76.3-25.11v113.41ZM2.61,143.1c58.95,2.1,76.3,67.62,76.3,67.62V54.8C69.8,21.87,2.61,29.69,2.61,29.69v113.41Z',
  },
  22: {
    id: 22,
    path: 'M56.18,273.7H-26.43c-9.55-20.95-14.93-44.5-14.93-69.4C-41.36,117.04,24.5,46.29,105.76,46.29s147.11,70.75,147.11,158.02c0,24.9-5.38,48.45-14.93,69.4h-82.61c19.4-16.01,31.96-41.1,31.96-69.4,0-48.36-36.51-87.57-81.53-87.57S24.22,155.94,24.22,204.3c0,28.31,12.56,53.4,31.96,69.4Z',
  },
  23: {
    id: 23,
    path: 'M-9.23,190.98V8.07h215.68v183.7h-50.72l-24.38-27.76c-5.34-5.34-.71-10.5-.71-10.5l29.72-34.52c5.61-5.61,0-10.68,0-10.68l-51.61-57.66c-5.07-5.07-8.9,0-8.9,0l-51.96,58.01c-4.8,4.8,0,9.97,0,9.97l31.68,34.34c4.63,6.05,0,9.61,0,9.61l-25.45,29.18-63.35-.79Z',
  },
  24: {
    id: 24,
    path: 'M126.49,265.31h-41.54V15.09h41.54v250.21ZM81.79,15.09h-3.86v250.21h3.86V15.09ZM133.51,15.09h-3.86v250.21h3.86V15.09h0Z',
  },
  25: {
    id: 25,
    path: 'M38.13,168.17v-12.31c8.38.91,50.37,4.04,99.9-17.57,0,0-39.87,32.3-99.9,29.88ZM98.29,215.09c-25.99,11.34-48.87,12.46-60.16,12.12v7.86c36.4-.74,60.16-19.98,60.16-19.98ZM38.13,205.47v12.04c59.61-1.26,96.67-33.62,96.67-33.62-43.22,20.55-81.88,21.95-96.67,21.58ZM161.05,155.33c-54.37,22.28-103.53,25.55-122.92,25.89v12.05c76.39-3.96,122.92-37.94,122.92-37.94Z',
  },
  26: {
    id: 26,
    path: 'M105.44,257.58l-33.79-143.27L37.87-28.97h135.15l-33.79,143.28-33.79,143.27Z',
  },
  27: {
    id: 27,
    path: 'M104.91,100.79h-12.92L33.18,18.49h12.92l58.82,82.3ZM185,226.35h12.92l-80.78-108.63h-12.92l80.78,108.63ZM204.04,226.35h12.92l-80.78-108.63h-12.92l80.78,108.63ZM65.14,18.49h-12.92l58.82,82.3h12.92L65.14,18.49ZM27.96,18.49h-12.92l58.82,82.3h12.91L27.96,18.49ZM166.86,226.35h12.92l-80.78-108.63h-12.91l80.78,108.63Z',
  },
  28: {
    id: 28,
    path: 'M16.94,26.68H-15.57l-1.85-30.88H15.12l1.82,30.88ZM18.77,57.56H-13.72l1.85,30.88H20.59l-1.82-30.88ZM22.41,119.32H-10.03l1.85,30.88H24.24l-1.82-30.88ZM26.06,181.07H-6.34l1.85,30.88H27.88l-1.82-30.88ZM29.71,242.82H-2.64l1.85,30.88H31.53l-1.82-30.88ZM80.2-4.19h-32.54l1.8,30.88h32.52l-1.78-30.88ZM49.46,26.68H16.94l1.82,30.88h32.49l-1.8-30.88ZM83.75,57.56h-32.49l1.8,30.88h32.47l-1.78-30.88ZM53.06,88.44H20.59l1.82,30.88h32.44l-1.8-30.88ZM87.3,119.32h-32.44l1.8,30.88h32.42l-1.78-30.88ZM56.66,150.19H24.24l1.82,30.88h32.4l-1.8-30.88ZM90.86,181.07h-32.4l1.8,30.88h32.37l-1.78-30.88ZM60.26,211.95H27.88l1.82,30.88h32.35l-1.8-30.88ZM94.41,242.82h-32.35l1.8,30.88h32.33l-1.78-30.88ZM145.28-4.19h-32.54l1.75,30.88h32.52l-1.73-30.88ZM114.49,26.68h-32.52l1.78,30.88h32.49l-1.75-30.88ZM148.73,57.56h-32.49l1.75,30.88h32.47l-1.73-30.88ZM118,88.44h-32.47l1.78,30.88h32.44l-1.75-30.88ZM152.19,119.32h-32.44l1.75,30.88h32.42l-1.73-30.88ZM121.5,150.19h-32.42l1.78,30.88h32.4l-1.75-30.88ZM155.65,181.07h-32.4l1.75,30.88h32.37l-1.73-30.88ZM125.01,211.95h-32.37l1.78,30.88h32.35l-1.75-30.88ZM159.11,242.82h-32.35l1.75,30.88h32.33l-1.73-30.88ZM210.35-4.19h-32.54l1.7,30.88h32.51l-1.68-30.88ZM179.52,26.68h-32.52l1.73,30.88h32.49l-1.71-30.88ZM213.72,57.56h-32.49l1.7,30.88h32.47l-1.68-30.88ZM182.93,88.44h-32.47l1.73,30.88h32.44l-1.7-30.88ZM217.08,119.32h-32.44l1.71,30.88h32.42l-1.68-30.88ZM186.34,150.19h-32.42l1.73,30.88h32.4l-1.7-30.88ZM220.44,181.07h-32.4l1.7,30.88h32.37l-1.68-30.88ZM189.75,211.95h-32.37l1.73,30.88h32.35l-1.71-30.88ZM223.81,242.82h-32.35l1.71,30.88h32.33l-1.68-30.88Z',
  },
  29: {
    id: 29,
    path: 'M152.99,321.46h-20.28V-.25h20.29v321.71h0ZM216.28,56.75v20.28H-17.18v-20.28s233.45,0,233.45,0Z',
  },
  30: { id: 30, path: 'M-8.71-12.32h216.51v288.65H-8.71V-12.32Z' },
};
const tshirtModelSlides: TShirtModel[][] = [
  [
    { id: 1, path: 'M2.63,11.5v18h40.5V11.5H2.63Z' },
    {
      id: 2,
      path: 'M31.5,1h13.5c-10.5,13-21,26-31.5,39H.75l2.25-2.25C12.5,25.5,22,13.25,31.5,1Z',
    },
    {
      id: 3,
      path: 'M2.25,1.31h6.96l13.66,24.69S31.75,9.06,36,1.31h7.5c-6.75,12.75-20.62,38.37-20.62,38.37C16.13,26.94,2.25,1.31,2.25,1.31Z',
    },
    {
      id: 4,
      path: 'M7.12.62h11.25v39.75H7.12V.62ZM27.38.62v39.75h11.25V.62h-11.25Z',
    },
  ],
  [
    {
      id: 5,
      path: 'M5.63,1h34.5v39c-.75-.25-5.3,0-5.3,0,0,0,2.13-29.48-11.95-29.48s-11.25,29.48-11.25,29.48h-6V1Z',
    },
    { id: 6, path: 'M14.63,1.75v37.5h16.5V1.75H14.63Z' },
    { id: 7, path: 'M.75,17.43h44.25v18H.75v-18Z' },
    {
      id: 8,
      path: 'M5.25,2.5h6v36h-6V2.5ZM15,38.5h6V2.5h-6v36ZM24.75,38.5h6V2.5h-6v36ZM34.5,2.5v36h6V2.5h-6Z',
    },
  ],
  [
    {
      id: 9,
      path: 'M2.63,2.5h40.5v6H2.63V2.5ZM2.63,12.25h40.5v6.75H2.63v-6.75ZM2.63,22h40.5v6.75H2.63v-6.75ZM2.63,32.5h40.5v6H2.63v-6Z',
    },
    {
      id: 10,
      path: 'M38.62,4v33c-.5-.25-1-.5-1.5-.75C27.13,25.5,17.12,14.75,7.13,4h31.5Z',
    },
    { id: 11, path: 'M.75,0v18h44.25V0H.75Z' },
    { id: 12, path: 'M41.62,37.75H4.12V13L12.81,3.25h20.15l8.67,10.52v23.98Z' },
  ],
  [
    {
      id: 13,
      path: 'M15.01,39.25h-5.25c-.4-19.27,8.71-24.15,13.5-37.5h12.75c-7.93,11.27-20.97,18.85-21,37.5Z',
    },
    {
      id: 14,
      path: 'M15.38,2.13h6v36.75h-6V2.13ZM24.37,2.13h6v36.75h-6V2.13ZM11.63,38.87h-6c.25-10.5.5-21,.75-31.5,1.75-1.5,3.5-3,5.25-4.5v36ZM40.12,38.87h-6V2.88c.75.25,1.5.5,2.25.75,1,1.5,2,3,3,4.5.25,10.25.5,20.5.75,30.75Z',
    },
    {
      id: 15,
      path: 'M41.65,37.93H4.15l-.05-34.55,18.8,21.05L41.27,3.07l.38,34.87Z',
    },
    {
      id: 16,
      path: 'M7.61,2.51c5.3-.27,13.93,1.46,17.41,6.01s8,19.72,4.34,29.99H7.61V2.51ZM26.57,5.33c9.4,3.9,13.06,20.22,11.04,33.19h-5.25c2.44-14.52-.56-23.22-5.79-33.19Z',
    },
  ],
  [
    {
      id: 17,
      path: 'M7.5,1.37c9.25,12.75,18.5,25.5,27.75,38.25h-7.5C18.5,26.88,9.25,14.12,0,1.37h7.5ZM18,1.37h-7.5c9.25,12.75,18.5,25.5,27.75,38.25h7.5C36.5,26.88,27.25,14.12,18,1.37Z',
    },
    {
      id: 18,
      path: 'M2.25,1.38c2.5.25,5,.5,7.5.75,6.77,6.32,7.66,21.28,4.5,33-3.74,2.78-5.05,4.42-12,4.5V1.38ZM43.5,1.38v38.25c-2.5-.25-5-.5-7.5-.75-6.77-6.32-7.66-21.28-4.5-33,3.74-2.78,5.05-4.42,12-4.5Z',
    },
    {
      id: 19,
      path: 'M39.75,37.37H6V14.28c0-3.58,3.43-7.16,3.43-7.16,0,0,3.19-3.5,13.45-3.5s12.88,3.98,12.88,3.98c0,0,4,2.5,4,6.97v22.8Z',
    },
    {
      id: 20,
      path: 'M17.63,38.87h-5.25V15.62h-5.25v-6c3-2.5,6-5,9-7.5h.75c.25,12.25.5,24.5.75,36.75ZM38.62,15.62h-5.25v23.25h-5.25c.25-12.25.5-24.5.75-36.75.75.25,1.5.5,2.25.75,2.5,2.5,5,5,7.5,7.5v5.25Z',
    },
  ],
  [
    {
      id: 21,
      path: 'M4.88,4c5.21-.09,7.38.73,10.5,2.25v30.75-1.5c-3.02-4.98-3.75-8.33-10.5-9.75V4ZM40.88,4v21.75c-6.52,1.22-9.02,5.06-10.5,11.25h-.75c-.19-10.04-1.27-23.91,1.5-31.5,3.25-.5,6.5-1,9.75-1.5Z',
    },
    {
      id: 22,
      path: 'M22.74,5.45c27.55,0,20.1,30.1,20.1,30.1l-12.07-.1s5.65-20.14-8.03-20.12-6.97,20.12-6.97,20.12l-12.75-.16S-4.81,5.45,22.74,5.45Z',
    },
    {
      id: 23,
      path: 'M4.13,3.25h37.5v34.5h-8.25c-1.75-2-3.5-4-5.25-6v-1.5c2.5-2.25,5-4.5,7.5-6.75l-12.75-12.75c-4.25,4-8.5,8-12.75,12v.75c2.5,2.5,5,5,7.5,7.5v1.5l-5.25,5.25H4.13V3.25Z',
    },
    {
      id: 24,
      path: 'M17.26,38.87h-.77V2.13h.77v36.75ZM29.26,38.87h-.77V2.13h.77v36.75ZM17.68,2.13h10.5v36.75h-10.5V2.13Z',
    },
  ],
  [
    {
      id: 25,
      path: 'M4.88,14.5v-3.75c12.38.28,20.52-1.8,29.25-4.5-.25.5-.5,1-.75,1.5-9.12,2.96-15.41,6.67-28.5,6.75ZM4.88,22v-3.75c14.26.21,25.23-3.42,36-6.75-.25.5-.5,1-.75,1.5-11.13,3.49-20.25,8.55-35.25,9ZM4.88,29.5v-3.75c11.49.18,19.14-2.8,27.75-5.25-.25.5-.5,1-.75,1.5-8.71,2.82-15.09,7.03-27,7.5ZM17.62,30.25h3c-.5.25-1,.5-1.5.75-3.45,2.51-8.48,3.59-14.25,3.75v-2.25c4.25-.75,8.5-1.5,12.75-2.25Z',
    },
    { id: 26, path: 'M4.13,2.5h37.5c-6.25,12-12.5,24-18.75,36h-.75L4.13,2.5Z' },
    {
      id: 27,
      path: 'M26,33.37,27.25,18.12h6.75c-2.75-3.75-5.5-7.5-8.25-11.25h-6c2.5,3.75,5,7.5,7.5,11.25ZM9.25,18.12h6.75c-2.75-3.75-5.5-7.5-8.25-11.25H1.75c2.5,3.75,5,7.5,7.5,11.25ZM18.25,18.12h6.75c-2.75-3.75-5.5-7.5-8.25-11.25h-6c2.5,3.75,5,7.5,7.5,11.25ZM37.25,34.12h6.75c-2.75-3.75-5.5-7.5-8.25-11.25h-6c2.5,3.75,5,7.5,7.5,11.25ZM19.25,34.12h6.75c-2.75-3.75-5.5-7.5-8.25-11.25h-6c2.5,3.75,5,7.5,7.5,11.25ZM28.25,34.12h6.75c-2.75-3.75-5.5-7.5-8.25-11.25h-6c2.5,3.75,5,7.5,7.5,11.25Z',
    },
    {
      id: 28,
      path: 'M2.63,1.75h5.25v5.25H2.63V1.75ZM13.13,1.75h4.5v5.25h-4.5V1.75ZM22.88,1.75h5.25v5.25h-5.25V1.75ZM33.37,1.75h4.5v5.25h-4.5V1.75ZM7.88,7h5.25v5.25h-5.25v-5.25ZM22.88,7v5.25h-4.5c-.25-1.75-.5-3.5-.75-5.25h5.25ZM28.12,7h5.25v5.25h-5.25v-5.25ZM37.87,7h5.25v5.25h-5.25v-5.25ZM2.63,12.25h5.25c-.25,2-.5,4-.75,6H2.63v-6ZM13.13,12.25h4.5v6h-4.5v4.5h4.5v6h-4.5v5.25h-5.25v-5.25H2.63v-6c1.75.25,3.5.5,5.25.75v4.5h5.25v-4.5h-5.25v-6h5.25v-5.25ZM22.88,12.25h5.25c-.25,2-.5,4-.75,6h-4.5v4.5c1.75.25,3.5.5,5.25.75v5.25h-5.25v5.25h-4.5v-6h4.5v-4.5h-4.5v-6h4.5v-5.25ZM33.37,12.25h4.5v5.25h5.25v6h-5.25v4.5h5.25v6h-5.25v-5.25h-4.5v5.25h-5.25c.25-2,.5-4,.75-6h4.5v-4.5c-1.75-.25-3.5-.5-5.25-.75v-5.25h5.25v-5.25ZM37.87,18.25v4.5h-4.5v-4.5h4.5ZM2.63,34h5.25v5.25H2.63v-5.25ZM13.13,34h4.5v5.25h-4.5v-5.25ZM22.88,34h5.25v5.25h-5.25v-5.25ZM33.37,34h4.5v5.25h-4.5v-5.25Z',
    },
  ],
  [
    { id: 29, path: 'M25.5.63h6v12h9v6h-9v21.75h-6v-21.75H5.25v-6h20.25V.63Z' },
    { id: 30, path: 'M4.88,2.87h36v35.25H4.88V2.87Z' },
  ],
];

const tshirtdUtils = {
  tshirtModelSlides,
  tshirtPatterns,
};

export default tshirtdUtils;
